import { ObservableQuery } from '@apollo/client';
import { Board } from '@ih/app/shared/apis/interfaces';

export class FindAllBoardsSuccess {
  public static readonly type = '[Project/Board/List] FindAllBoardsSuccess';
  constructor(
    public readonly result: ObservableQuery.Result<{
      findAllBoards: Board[];
    }>,
  ) {}
}
